
  import { defineComponent, ref, onMounted, computed } from 'vue';
  import { useRouter } from 'vue-router';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';

  export default defineComponent({
    name: 'quality-ranges-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const { can } = useAbility();
      const store = useStore();
      const router = useRouter();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('rangesFinishingQuality'), [
          translate('ive'),
        ]);
      });

      await store.dispatch(Actions.GET_QUALITY_RANGES);
      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('qualityNameEn'),
          key: 'titleEn',
          sortable: true,
        },
        {
          name: translate('qualityNameAr'),
          key: 'titleAr',
          sortable: true,
        },
        {
          name: translate('from'),
          key: 'from',
          sortable: true,
        },
        {
          name: translate('to'),
          key: 'to',
          sortable: true,
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);

      const toggleStatusQualityRange = async (qualityRange) => {
        const deletedMessage = qualityRange.isActive
          ? 'confirmInActive'
          : 'confirmActive';
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          text: translate(deletedMessage),
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(Actions.DELETE_QUALITY_RANGE, qualityRange.id);
          await store.dispatch(Actions.GET_QUALITY_RANGES);
          loading.value = false;
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
          } else {
            const successMsg = qualityRange.isActive
              ? 'SUCCESSFULLY_INACTIVATED'
              : 'SUCCESSFULLY_ACTIVEATED';
            Swal.fire({
              text: translate(successMsg),
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: translate('ok'),
              customClass: {
                confirmButton: 'btn btn-light-primary',
              },
            });
          }
        }
      };

      const editQualityRange = (id) => {
        router.push({ name: 'qulaity-ranges-editing', params: { id } });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_QUALITY_RANGE_CURRENT_PAGE, val);
        await store.dispatch(Actions.GET_QUALITY_RANGES);
        loading.value = false;
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        tableData: computed(() => store.getters.qualityRangesList),
        tableHeader,
        toggleStatusQualityRange,
        translate,
        totalItems: computed(() => store.getters.qualityRangesListCount),
        pageChanged,
        goTo,
        editQualityRange,
        loading,
        can,
      };
    },
  });
